import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Highlights() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    axios.get(`${API}/menu`).then((r) => setItems(r.data));
  }, []);

  const categories = ["All", ...Array.from(new Set(items.map((i) => i.category)))];
  const visible = filter === "All" ? items : items.filter((i) => i.category === filter);

  return (
    <div data-testid="highlights-page">
      <section className="sd-page-hero">
        <h1>Menu Highlights</h1>
        <p className="text-white/90 mt-3">From signature subs to party pizza — fresh, fast, famous.</p>
      </section>

      <section className="py-12 bg-[#f6f1e8]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap gap-2 justify-center mb-10" data-testid="category-filters">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                className={`px-5 py-2 rounded-full font-display tracking-wide text-sm transition ${
                  filter === c
                    ? "bg-[#cd0202] text-white"
                    : "bg-white text-[#cd0202] border border-[#cd0202]"
                }`}
                data-testid={`filter-${c.toLowerCase()}`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="menu-grid">
            {visible.map((item) => (
              <Link
                to={`/highlights/${item.slug}`}
                key={item.slug}
                className="bg-white rounded shadow hover:shadow-2xl transition overflow-hidden block"
                data-testid={`menu-item-${item.slug}`}
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <h3 className="text-[#cd0202] text-xl font-display mb-2">{item.name}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed line-clamp-3">
                    {item.description}
                  </p>
                  <p className="mt-3 text-[#cd0202] font-display text-lg">{item.price_label}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
